//@flow
import * as Immutable from 'immutable';

import {
    PjpMetricGraph,
    ReferenceLine
} from 'common/models/flow/PjpMetricGraph';
import type {
    PjpMetricGraphModelType,
    ReferenceLineModelType
} from 'common/models/flow/PjpMetricGraph';
import {
    validatable,
    validateId,
    validate,
    softValidateAll
} from 'common/utils/ValidationUtil';
import { PjpMetricQuery } from 'common/models/internal/PjpMetricQuery';

@validatable
class InternalPjpMetricGraph extends PjpMetricGraph {
    static fromJS(json: PjpMetricGraphModelType): InternalPjpMetricGraph {
        const state: Object = Object.assign({}, json);
        state.graphQueries = Immutable.List(state.graphQueries);
        state.statisticQueries = Immutable.List(state.statisticQueries);
        state.refLines = state.refLines
            ? Immutable.List(state.refLines).map(item =>
                  InternalReferenceLine.fromJS(item)
              )
            : state.refLines;
        state.queries = Immutable.List(state.queries).map(item =>
            PjpMetricQuery.fromJS(item)
        );
        return new this(Immutable.Map(state));
    }

    @softValidateAll
    hasValidationErrors(): boolean {
        const { id } = this;
        if (validateId(id)) {
            return true;
        }
        return false;
    }

    @validate
    setId(id: string): this {
        return super.setId(id);
    }

    validateId() {
        const { id } = this;
        return validateId(id);
    }

    get queries(): Immutable.List<PjpMetricQuery> {
        return this._state.get('queries');
    }

    getGraphQuery(): PjpMetricQuery {
        return this.queries.get(this.graphQueries.get(0));
    }

    get refLines(): ?Immutable.List<ReferenceLine> {
        return this._state.get('refLines');
    }
}

class InternalReferenceLine extends ReferenceLine {
    static fromJS(json: ReferenceLineModelType): InternalReferenceLine {
        const state: Object = Object.assign({}, json);
        return new this(Immutable.Map(state));
    }
}

export {
    InternalPjpMetricGraph as PjpMetricGraph,
    InternalReferenceLine as ReferenceLine
};
